import "../App.css";
import {
  tutorial2Maya1,
  tutorial2Maya2,
  tutorial2Maya3,
  tutorial2Maya4,
  tutorial2Maya5,
  tutorial2Maya6,
  tutorial2Maya7,
  tutorialButtonNextPage,
  tutorialButtonPreviousPage,
  tutorialButtonStartLevel,
  tutorialTitle
} from "../strings";

function Tutorial2Maya({ finishTutorial, page, handleNext, handlePrevious }) {

  const maxPages = 5; // Note that the first page has index 0. This means maxPages-1 is the last page.

  return (
    <div>
      <div className="tutorial-title">
        {tutorialTitle}
      </div>
      <div className="tutorial-body">
        {page === 0 && 
          <div>
            {tutorial2Maya1}
            <br></br>&nbsp;<br></br>
            {tutorial2Maya2}
          </div>
        }
        {page === 1 && 
          <div>
            {tutorial2Maya3}
          </div>
        }
        {page === 2 && 
          <div>
            {tutorial2Maya4}
            <br></br>&nbsp;<br></br>
            {tutorial2Maya5}
          </div>
        }
        {page === 3 && 
          <div>
            {tutorial2Maya6}
          </div>
        }
        {page === 4 && 
          <div>
            {tutorial2Maya7}
          </div>
        }
      </div>

      {/* Button to start level. */}
      {page === (maxPages-1) && 
        <button
        onClick={finishTutorial}
          className="tutorial-next-button"
        >
        {tutorialButtonStartLevel}
        </button>
      }

      {/* Button to go to previous page. */}
      {page > 0 && 
        <button
          onClick={handlePrevious}
          className="tutorial-previous-button"
        >
        {tutorialButtonPreviousPage}
        </button>
      }

      {/* Button to go to next page. */}
      {page < (maxPages-1) && 
        <button
          onClick={handleNext}
          className="tutorial-next-button"
        >
        {tutorialButtonNextPage}
        </button>
      }
    </div>
  );
}

export default Tutorial2Maya;
